<template>
  <v-toolbar color="primary" fixed dark app>
    <v-toolbar-title class="ml-0 pl-3">
      <v-toolbar-side-icon
        @click.stop="handleDrawerToggle"
      ></v-toolbar-side-icon>
    </v-toolbar-title>
    <!-- <v-text-field
      flat
      solo-inverted
      prepend-icon="search"
      label="Buscar"
      class="hidden-sm-and-down"
    ></v-text-field> -->
    <h4 style="color: white" class="ml-5">
      Versión {{ this.$store.state.version }}
    </h4>

    <v-btn
      v-if="$store.state.realizarCorteCaja"
      color="red darken-4"
      @click="openDialogCorteCaja"
    >
      <v-icon dark left> info </v-icon>REALIZAR CORTE DE SUCURSAL
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn color="primary darken-4" href="#" @click="logOut()"
      >CERRAR SESIÓN</v-btn
    >
    <v-btn icon href="https://github.com/tookit/vue-material-admin">
      <v-icon>fa fa-github</v-icon>
    </v-btn>
    <v-btn icon @click="handleFullScreen()">
      <v-icon>fullscreen</v-icon>
    </v-btn>
    <v-menu
      offset-y
      origin="center center"
      class="elelvation-1"
      :nudge-bottom="14"
      transition="scale-transition"
    >
      <v-btn icon flat slot="activator">
        <v-badge color="red" overlap>
          <span slot="badge">3</span>
          <v-icon medium>notifications</v-icon>
        </v-badge>
      </v-btn>
      <notification-list></notification-list>
    </v-menu>
    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
    >
      <v-btn icon large flat slot="activator">
        <v-avatar size="30px">
          <img src="/images/usuario/usuario-m-140.png" alt="Usuarios" />
        </v-avatar>
      </v-btn>
      <v-list class="pa-0">
        <v-list-tile
          v-for="(item, index) in items"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          @click="item.click"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="index"
        >
          <v-list-tile-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
    <form-corte-caja
      v-if="$store.state.realizarCorteCaja"
      ref="dialogCorteCaja"
    ></form-corte-caja>
    <loading-alert></loading-alert>
  </v-toolbar>
</template>
<script>
import authService from "@/services/authService";
import NotificationList from "@/components/widgets/list/NotificationList";
import Util from "@/util";
import FormCorteCaja from "@/views/corte-caja/FormCorteCaja";
import LoadingAlert from "@/components/LoadingAlert";

export default {
  name: "app-toolbar",
  components: {
    NotificationList,
    FormCorteCaja,
    LoadingAlert
  },
  data: () => ({
    items: [
      {
        icon: "account_circle",
        href: "#",
        title: "Perfil",
        click: (e) => {
          console.log(e);
        },
      },
      {
        icon: "settings",
        href: "#",
        title: "Contraseña",
        click: (e) => {
          console.log(e);
        },
      },
      {
        icon: "fullscreen_exit",
        href: "#",
        title: "Cerrar Sesión",
        click: (e) => {
          authService
            .logOut()
            .then((result) => {
              localStorage.setItem("esAnonimo", "true");
              localStorage.setItem("access_token", null);
              localStorage.setItem("expiracion_token", null);
              localStorage.removeItem("esAnonimo");
              localStorage.removeItem("access_token");
              localStorage.removeItem("expiracion_token");
              localStorage.removeItem("user_logged");
              window.getApp.$emit("APP_LOGOUT");
            })
            .catch((e) => {
              console.log(e);
              self.$store.state.snackbar.color = "error";
              self.$store.state.snackbar.text = e.response.data.error;
              self.$store.state.snackbar.visible = true;
              self.usuario.password = "";
            })
            .finally((r) => {
              self.loading = false;
            });
        },
      },
    ],
  }),
  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
  },
  methods: {
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    },
    openDialogCorteCaja() {
      this.$store.state.tituloForm = "AGREGAR CORTE DE CAJA";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogCorteCaja.getCorteCaja();
      this.$refs.dialogCorteCaja.openDialog();
    },
    logOut() {
      let self = this;
      authService
        .logOut()
        .then((result) => {
          localStorage.setItem("esAnonimo", "true");
          localStorage.setItem("access_token", null);
          localStorage.setItem("expiracion_token", null);
          localStorage.removeItem("esAnonimo");
          localStorage.removeItem("access_token");
          localStorage.removeItem("expiracion_token");
          localStorage.removeItem("user_logged");
          window.getApp.$emit("APP_LOGOUT");
        })
        .catch((e) => {
          console.log(e);
          self.$store.state.snackbar.color = "error";
          self.$store.state.snackbar.text = e.response.data.error;
          self.$store.state.snackbar.visible = true;
          self.usuario.password = "";
        })
        .finally((r) => {
          self.loading = false;
        });
    },
  },
};
</script>
